import { render, staticRenderFns } from "./ClientRecentProjects.vue?vue&type=template&id=6cbe4e4f&"
import script from "./ClientRecentProjects.vue?vue&type=script&lang=js&"
export * from "./ClientRecentProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbe4e4f')) {
      api.createRecord('6cbe4e4f', component.options)
    } else {
      api.reload('6cbe4e4f', component.options)
    }
    module.hot.accept("./ClientRecentProjects.vue?vue&type=template&id=6cbe4e4f&", function () {
      api.rerender('6cbe4e4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/ClientRecentProjects.vue"
export default component.exports